import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

/**
 * Gate for signed-in routes.
 *
 * Renders nothing decisive while the initial session check runs, so a reload
 * does not flash the login screen at somebody who is in fact signed in.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="flex min-h-screen items-center justify-center text-muted-foreground">
        Učitavanje…
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/prijava" replace state={{ from: location.pathname }} />;
  }

  if (user.must_change_password && location.pathname !== "/postavke/lozinka") {
    return <Navigate to="/postavke/lozinka" replace />;
  }

  return <>{children}</>;
}
